export const badgesToDisplay = ['Initiator', 'Ambassador', 'Pionnier'];